import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrRadioComponent } from './pr-radio.component';

@NgModule({
  declarations: [PrRadioComponent],
  imports: [CommonModule],
  exports: [PrRadioComponent],
})
export class PrRadioModule {}
